import { DefaultState } from '@src/redux/types'

import { LETTER_INCOMING_LIST, LETTER_OUTGOING_LIST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [LETTER_INCOMING_LIST]: DefaultState<`${typeof API.LETTER_INCOMING}`, 'get'>
  [LETTER_OUTGOING_LIST]: DefaultState<`${typeof API.LETTER_OUTGOING}`, 'get'>
} = () => ({
  [LETTER_INCOMING_LIST]: defaultState(),
  [LETTER_OUTGOING_LIST]: defaultState(),
})
